import { render, staticRenderFns } from "./EmergencyResponseTrainingDetail.vue?vue&type=template&id=c1b4df94&scoped=true&"
import script from "./EmergencyResponseTrainingDetail.vue?vue&type=script&lang=js&"
export * from "./EmergencyResponseTrainingDetail.vue?vue&type=script&lang=js&"
import style0 from "./EmergencyResponseTrainingDetail.vue?vue&type=style&index=0&id=c1b4df94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b4df94",
  null
  
)

export default component.exports